const Menu =  [
    { header: 'Pengawas Ujian' },
    {
        path    : '/',
        title   : 'Ujian Tulis',    
        name    : 'tes/ujian_excel',  
        icon    : 'local_library', 
    },
    {
        path    : '/tes/ujian_excel',
        title   : 'Rekap',    
        name    : 'tes/ujian_excel',  
        icon    : 'flip_to_front', 
    }, 
    {
        path    : '/tes/ujian',
        title   : 'Ujian',    
        name    : 'tes/ujian',  
        icon    : 'flip_to_front', 
        visible : false,
    },             
    {
        path    : '/tes/ujian_view',
        title   : 'View',    
        name    : 'tes/ujian_view',  
        icon    : 'flip_to_front',
        visible : false, 
    }, 
];

import Remenu from '@/util/remenu';
export default Remenu(Menu);
